module.exports = __webpack_public_path__ + "img/sfq4.d4d3f527.png";